import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;

export function useAppConfig() {
  const [cfg, setCfg] = useState(cached || { invite_only: false, loaded: false });
  useEffect(() => {
    if (cached) return;
    api.get("/config").then(({ data }) => { cached = { ...data, loaded: true }; setCfg(cached); })
      .catch((e) => console.error("config load failed", e));
  }, []);
  return cfg;
}
